import { AfnamegroepI, DeelnemerI } from '@models/deelnemer.model';
import { ProductKey, StartCodeByProduct } from '@models/startcode.model';

export interface DeelnemersStateModel {
  deelnemers: DeelnemerI[];
  deelnemersLocationIds: string[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
  cached: boolean;
  selectedDeelnemerId: string;
  selectedDeelnemersIds: string[];
  selectedGroep: AfnamegroepI | null;
  creatingStartcodes: boolean;
  printStartcodes: boolean;
  updatingPlanningen: boolean;
  startcodesByProduct: StartCodeByProduct | null;
  startcodeProductKeys: ProductKey[] | null;
}

export const DeelnemersInitialState = {
  deelnemers: [] as DeelnemerI[],
  deelnemersLocationIds: [],
  loading: false,
  error: null,
  loaded: false,
  cached: false,
  selectedDeelnemerId: '',
  selectedDeelnemersIds: [],
  selectedGroep: null,
  creatingStartcodes: false,
  printStartcodes: false,
  updatingPlanningen: false,
  startcodesByProduct: null,
  startcodeProductKeys: null,
};
